/* eslint-disable */
"use strict";
function productData() {
    return {
        productEl: null,
        connectorPricing: [],
        productType: {},
        productLocations: [],
        productAvailabilities: [],
        storeLocation: {},
        productWarehouse: {},
        productAvailable: false,
        selectedOptions: "",
        storePrice: {},
        storePriceWithCompareAtPrice: false,
        productBadges: {},
        cartPrice: "",
        isBikeInCart: null,
        load: false,

        init() {
            this.productEl = this.$el;

            this.connectorPricing =
                this.getProductDataFromJSON(".productPriceStoreJSON") || [];

            this.productType =
                this.getProductDataFromJSON(".productTypeJSON") || {};

            document.addEventListener("store-changed", (event) => {
                const storeDetail = event.detail;
                const storeId = storeDetail.storeId;
                const storeName = storeDetail.storeTitle;

                const selectedVariant = this.$el
                    .querySelector("[data-selected-variant]")
                    .getAttribute("data-selected-variant");
                this.updatePrice(selectedVariant, storeId);

                this.updateLocation(storeName);
            });

            document.addEventListener("update-cart-items", (event) => {
                const items = event.detail.items;
                this.cartItemsHasBike(items);
            });
        },

        async initVariant(selectedVariant, useAllVariants = false) {
            this.productLocations =
                this.getProductDataFromJSON(".productLocationsJSON") || [];
            this.productAvailabilities =
                this.getProductDataFromJSON(".productAvailabilityStoreJSON") ||
                [];

            const fetchPromises = this.productAvailabilities
                .filter((e) => e.id !== selectedVariant)
                .map(
                    async (e) =>
                        await this.fetchVariantData(
                            this.productAvailabilities[0].product_handle,
                            e.id
                        )
                );

            Promise.all(fetchPromises)
                .then(() => {
                    if (useAllVariants) {
                        this.updateLocationByAllVariants();
                    } else {
                        this.updateLocation(selectedVariant);
                    }
                    this.updatePrice(selectedVariant);
                    this.updateStyleOptions();
                })
                .catch((error) => {
                    console.error(
                        "Error in one of the fetch operations:",
                        error
                    );
                });
        },
        
        processAllVariants(selectedVariant) {
            this.initVariant(selectedVariant, true);
        },

        async fetchVariantData(productHandle, variantId) {
            this.load = false;
            await fetch(
                `/products/${productHandle}?variant=${variantId}&section_id=variant-data-handler`
            )
                .then((response) => {
                    if (!response.ok)
                        throw new Error(`Error ${response.status}`);
                    return response.text();
                })
                .then((html) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");

                    const newJsonElement =
                        doc.querySelector(".variantDataJSON");
                    if (newJsonElement) {
                        try {
                            const jsonData = JSON.parse(
                                newJsonElement.textContent.trim()
                            );

                            if (
                                Array.isArray(jsonData) &&
                                jsonData.length > 0
                            ) {
                                const availability = jsonData[0].availability;

                                const variant = this.productAvailabilities.find(
                                    (e) => e.id == variantId
                                );

                                if (variant) {
                                    variant.availability = availability;
                                }

                                setTimeout(() => {
                                    this.load = true;
                                }, 500);
                            } else {
                                console.error("No valid JSON data available");
                            }
                        } catch (error) {
                            console.error(error, newJsonElement.textContent);
                        }
                    } else {
                        console.error("variantDataJSON not found");
                    }
                })
                .catch((error) => console.error("error variant fetch", error));
        },

        updatePrice(selectedVariant, storeCode = window.OD.store.id) {
            if (!this.connectorPricing || !storeCode) return;
            const getPrice = this.getPriceByStore(selectedVariant, storeCode);

            if (getPrice?.price) {
                this.storePriceWithCompareAtPrice =
                    getPrice.compareAtPrice &&
                    getPrice.compareAtPrice > getPrice.price;

                if (this.storePriceWithCompareAtPrice) {
                    const savingsAmount = (
                        getPrice.compareAtPrice - getPrice.price
                    ).toFixed(2);
                    const savingsPercentage = (
                        ((getPrice.compareAtPrice - getPrice.price) /
                            getPrice.compareAtPrice) *
                        100
                    ).toFixed(0);

                    this.productBadges.discount = {
                        amount: `Save $${savingsAmount}`,
                        percentage: `Save ${savingsPercentage}%`
                    };
                }

                this.cartPrice = JSON.stringify(getPrice);

                this.storePrice = {
                    digit: {
                        price: getPrice.price,
                        compareAtPrice: getPrice.compareAtPrice
                    },
                    ...this.addDollarSignToPricesInPlace(getPrice)
                };
            } else {
                this.storePrice = {
                    price: " "
                };
                this.storePriceWithCompareAtPrice = false;
                this.productAvailable = false;
            }
        },

        updateStyleOptions() {
            const optionFields = this.productEl.querySelectorAll(
                ".variant-picker__option"
            );

            optionFields.forEach((field) => {
                const options = field.querySelectorAll("input[type='radio']");

                options.forEach((option) => {
                    const value = option.dataset.optionValue;
                    const label = field.querySelector(
                        `label[for='${option.id}']`
                    );

                    const isAvailable = this.productAvailabilities.some(
                        (variant) =>
                            variant.options.includes(value) &&
                            variant.availability.some(
                                (avail) =>
                                    (avail.location_name === "Warehouse" ||
                                        avail.location_name ===
                                            this.storeLocation?.location
                                                ?.name) &&
                                    avail.available
                            )
                    );

                    if (isAvailable) {
                        option.classList.remove("is-disabled");
                        label.classList.remove("is-disabled");
                    } else {
                        option.classList.add("is-disabled");
                        label.classList.add("is-disabled");
                    }
                });
            });
        },

        updateLocation(variant, storeName = window.OD.store.location_title) {
            if (!storeName) return;

            const { matchingStoreLocation } =
                this.getLocationByStore(storeName);

            this.storeLocation = matchingStoreLocation || {};

            let variantAvailabilityArr = this.productAvailabilities.filter(
                (e) => e.id == variant
            );

            let storeAvailabilityObj =
                variantAvailabilityArr[0]?.availability.find(
                    (loc) =>
                        loc?.location_id == this.storeLocation?.location?.id
                );

            let warehouseAvailabilityObj =
                variantAvailabilityArr[0]?.availability.find(
                    (loc) => loc.location_name === "Warehouse"
                );

            let storeAvailability = Boolean(
                storeAvailabilityObj?.available && storeAvailabilityObj?.price
            );

            let warehouseAvailability = Boolean(
                warehouseAvailabilityObj?.location_name === "Warehouse" &&
                    warehouseAvailabilityObj?.available
            );

            this.storeLocation = {
                ...this.storeLocation,
                available: storeAvailability
            };

            this.productWarehouse = {
                ...this.productWarehouse,
                available: warehouseAvailability
            };

            this.productAvailable = storeAvailability || warehouseAvailability;
        },
        
        updateLocationByAllVariants(storeName = window.OD.store.location_title) {
            if (!storeName) return;
            
            const { matchingStoreLocation } = this.getLocationByStore(storeName);
            
            this.storeLocation = matchingStoreLocation || {};
            
            let isStoreAvailable = false;
            let isWarehouseAvailable = false;

            this.productAvailabilities.forEach((variant) => {
                let storeAvailabilityObj = variant.availability.find(
                    (loc) => loc?.location_id == this.storeLocation?.location?.id
                );
                
                let warehouseAvailabilityObj = variant.availability.find(
                    (loc) => loc.location_name === "Warehouse"
                );
                
                let storeAvailability = Boolean(
                    storeAvailabilityObj?.available && storeAvailabilityObj?.price
                );
                
                let warehouseAvailability = Boolean(
                    warehouseAvailabilityObj?.location_name === "Warehouse" &&
                    warehouseAvailabilityObj?.available
                );
                
                if (storeAvailability) isStoreAvailable = true;
                if (warehouseAvailability) isWarehouseAvailable = true;
            });
            
            this.storeLocation = {
                ...this.storeLocation,
                available: isStoreAvailable
            };
            
            this.productWarehouse = {
                ...this.productWarehouse,
                available: isWarehouseAvailable
            };

            this.productAvailable = isStoreAvailable || isWarehouseAvailable;
        },

        cartItemsHasBike(items) {
            const cartHasBike = items?.some(
                (el) => el.properties?._isBike === "true"
            );
            this.isBikeInCart = cartHasBike;
        },

        addDollarSignToPricesInPlace(priceObj) {
            for (const key in priceObj) {
                if (priceObj[key] !== null && !isNaN(priceObj[key])) {
                    priceObj[key] = `$${priceObj[key].toLocaleString("en-AU", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`;
                }
            }

            return priceObj;
        },

        getProductDataFromJSON(classJSON) {
            const scriptJSON =
                this.$el.querySelector(classJSON) ||
                this.productEl.querySelector(classJSON);

            if (scriptJSON) {
                try {
                    const dataOBJ = JSON.parse(scriptJSON.textContent);

                    if (
                        dataOBJ &&
                        (Array.isArray(dataOBJ) || typeof dataOBJ === "object")
                    ) {
                        return dataOBJ;
                    } else {
                        console.error(
                            `Invalid JSON structure: ${classJSON}`,
                            dataOBJ
                        );
                        return null;
                    }
                } catch (error) {
                    console.error(`Error parsing JSON: ${classJSON}`, error);
                    return null;
                }
            } else {
                console.error("No JSON found for class:", classJSON);
                return null;
            }
        },

        parsePrice(price) {
            return price != null && !isNaN(price) ? parseFloat(price) : 0;
        },

        getPriceByStore(selectedVariant, storeCode) {
            if (!this.connectorPricing) return;

            const matchingItemObj = this.connectorPricing.find(
                (item) => Object.keys(item)[0] == selectedVariant
            );
            const matchingItem = matchingItemObj
                ? Object.values(matchingItemObj)[0]
                : null;

            if (!matchingItem) {
                console.log("No item found with these Selected Variant");
                return null;
            }

            const priceObj = matchingItem.find(
                (price) => price.storeCode == storeCode
            );

            if (!priceObj) {
                console.log("Price not found for selected:", storeCode);
                return null;
            }

            const { price, compareAtPrice } = priceObj;

            return {
                price: this.parsePrice(price),
                compareAtPrice: this.parsePrice(compareAtPrice)
            };
        },

        getLocationByStore(storeName) {
            if (!this.productLocations || !storeName) {
                console.warn("Product locations or store name is not defined.");
                return null;
            }

            const matchingStoreLocation = this.productLocations.find(
                (item) =>
                    item.location.name &&
                    (storeName.includes(item.location.name) ||
                        storeName == item.location.name)
            );

            const matchingProductWarehouse = this.productLocations.find(
                (item) => item.location.name === "Warehouse"
            );

            if (!matchingStoreLocation && !matchingProductWarehouse) {
                console.warn(
                    "No matching store or warehouse found for storeName:",
                    storeName
                );
                return null;
            }

            return { matchingStoreLocation, matchingProductWarehouse };
        }
    };
}
